import { Fragment, type ReactNode } from "react";

export function renderInlineMarkdown(input: string): ReactNode {
  const tokens = input.split(/(\*\*[^*]+\*\*|\*[^*]+\*)/g);
  const occurrences = new Map<string, number>();
  return tokens
    .filter((t) => t.length > 0)
    .map((token) => {
      const occurrence = occurrences.get(token) ?? 0;
      occurrences.set(token, occurrence + 1);
      const key = `${token}:${occurrence}`;
      if (token.startsWith("**") && token.endsWith("**")) {
        return <strong key={key}>{token.slice(2, -2)}</strong>;
      }
      if (token.startsWith("*") && token.endsWith("*")) {
        return <em key={key}>{token.slice(1, -1)}</em>;
      }
      return <Fragment key={key}>{token}</Fragment>;
    });
}
